import React, { useState } from 'react';
import { GeneralOverviewPageRenderedComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import FundTable from './CoverageRatioFundsTable.component';
import SummaryTable from './SummaryTable.component';
import { Grid } from '@mui/material';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import { useArticle48CoverageRulesPageQuery } from '../../../../api/rs-hg/risk/hooks/queries';
import type { Article48CoverageRulesPayload } from '../../../../api/rs-hg/risk/article48CoverageRules.types';

const CoverageRatio: React.FC<GeneralOverviewPageRenderedComponentProps> = () => {
  const [issuer, setIssuer] = useState<string>('');
  const coverageRatioQuery = useArticle48CoverageRulesPageQuery();

  return (
    <QueryBoundary<Article48CoverageRulesPayload>
      isLoading={coverageRatioQuery.isLoading}
      isFetching={coverageRatioQuery.isFetching}
      isError={coverageRatioQuery.isError}
      error={coverageRatioQuery.error}
      data={coverageRatioQuery.data?.data}
      loadingMessages={['Loading Coverage Ratio Data']}
      errorMessage="Unable to load Coverage Ratio data."
      noDataMessage="No Coverage Ratio data available."
    >
      {(data) => (
        <Grid container spacing={2} style={{ padding: 8 }}>
          <SummaryTable data={data} issuer={issuer} setIssuer={setIssuer} />
          <FundTable data={data} issuer={issuer} />
        </Grid>
      )}
    </QueryBoundary>
  );
};

export default CoverageRatio;
